import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BroadcastingState } from './types'

const initialBroadcastingState: BroadcastingState = {
  publishedFlights: []
}

export const broadcastingSlice = createSlice({
  name: 'broadcasting',
  initialState: initialBroadcastingState,
  reducers: {
    addPublishedFlightId(state, action: PayloadAction<string>) {
      state.publishedFlights.push(action.payload)
    }
  }
})

export const reducer = broadcastingSlice.reducer

export const { addPublishedFlightId } = broadcastingSlice.actions

// Rugby penalty countdown //

// export function getPenaltyCountdownState(): AppThunk {
//   return async (dispatch) => {
//     try {
//       const response = await api.getPenaltyCountdownState()
//       dispatch(setPenaltyCountdownActive(response.data.enabled))
//     } catch (error) {
//       dispatch(handleAPIError(error, 'errorDetail'))
//     }
//   }
// }

// export function startPenaltyCountdown(): AppThunk {
//   return async (dispatch) => {
//     try {
//       await api.startPenaltyCountdown()
//       dispatch(getPenaltyCountdownState())
//     } catch (error) {
//       dispatch(handleAPIError(error, 'errorDetail'))
//     }
//   }
// }

// export function clearPenaltyCountdown(): AppThunk {
//   return async (dispatch) => {
//     try {
//       await api.clearPenaltyCountdown()
//       dispatch(getPenaltyCountdownState())
//     } catch (error) {
//       dispatch(handleAPIError(error, 'errorDetail'))
//     }
//   }
// }
